/**
 * Detects if the device has touch capabilities
 */
export const hasTouchScreen = (): boolean => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }

    if ('maxTouchPoints' in navigator) {
        return navigator.maxTouchPoints > 0;
    }

    if ('ontouchstart' in window) {
        return true;
    }

    if (window.matchMedia) {
        const coarsePointerQuery = window.matchMedia('(pointer: coarse)');
        if (coarsePointerQuery.matches) {
            return true;
        }

        const anyPointerQuery = window.matchMedia('(any-pointer: coarse)');
        if (anyPointerQuery.matches) {
            return true;
        }
    }

    if ('orientation' in window) {
        return true;
    }

    if (navigator && 'userAgent' in navigator) {
        const userAgent = (navigator as Navigator).userAgent.toLowerCase();
        const mobileKeywords = ['android', 'iphone', 'ipad', 'ipod', 'blackberry', 'windows phone'];

        if (mobileKeywords.some(keyword => userAgent.includes(keyword))) {
            return true;
        }
    }

    return false;
};

export const isMobile = (breakpoint: number = 1024): boolean => {
    if (typeof window === 'undefined') {
        return false;
    }
    return window.innerWidth < breakpoint;
};

export const isMobileDevice = (): boolean => {
    return hasTouchScreen() && isMobile();
};

export const hasHybridInput = (): boolean => {
    if (typeof window === 'undefined' || typeof navigator === 'undefined') {
        return false;
    }

    const hasTouch = hasTouchScreen();
    const hasMouse = window.matchMedia && window.matchMedia('(pointer: fine)').matches;

    return hasTouch && hasMouse;
};
